import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { configsService } from '@/services/http/configsService'

export const useIdeaFeedParams = () => {
  const { toast } = useToast()

  const {
    data: ideaFeedParams,
    isError,
    isLoading,
    refetch: refetchIdeaFeedParams,
  } = useQuery({
    queryKey: ['ideaFeedParams'],
    queryFn: () => configsService.getIdeaFeedParams(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao buscar parâmetros de visualização de iniciativas',
        variant: 'destructive',
      })
  }, [isError, toast])

  return {
    ideaFeedParams,
    isLoading,
    refetchIdeaFeedParams,
  }
}
